import { render, staticRenderFns } from "./UpdatePopup.vue?vue&type=template&id=c697d470&"
import script from "./UpdatePopup.vue?vue&type=script&lang=js&"
export * from "./UpdatePopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports